// SVG icon paths
export const icons = {
  activeJobs: `${process.env['PUBLIC_URL'] || ''}/images/active-jobs.svg`,
  activeJobsTransparent: `${process.env['PUBLIC_URL'] || ''}/images/active-jobs-transparent.svg`,
  failedJobs: `${process.env['PUBLIC_URL'] || ''}/images/failed-jobs.svg`,
  failedJobsTransparent: `${process.env['PUBLIC_URL'] || ''}/images/failed-jobs-transparent.svg`,
  failureRate: `${process.env['PUBLIC_URL'] || ''}/images/failure-rate.svg`,
  failureRateTransparent: `${process.env['PUBLIC_URL'] || ''}/images/failure-rate-transparent.svg`,
  jobDuration: `${process.env['PUBLIC_URL'] || ''}/images/average-job-duration.svg`,
  jobDurationTransparent: `${process.env['PUBLIC_URL'] || ''}/images/average-job-duration-transparent.svg`,
  resourceUtilization: `${process.env['PUBLIC_URL'] || ''}/images/resource-utilization.svg`,
  resourceUtilizationTransparent: `${process.env['PUBLIC_URL'] || ''}/images/resource-utilization-transparent.svg`,
  cpuCores: `${process.env['PUBLIC_URL'] || ''}/images/average-cpu-cores.svg`,
  cpuCoresTransparent: `${process.env['PUBLIC_URL'] || ''}/images/average-cpu-cores-transparent.svg`,
  arrowTopRight: `${process.env['PUBLIC_URL'] || ''}/images/arrow-top-right.svg`,
  arrowTopRightTransparent: `${process.env['PUBLIC_URL'] || ''}/images/arrow-top-right-transparent.svg`,
};

// Metric cards data
export const mainMetrics = [
  {
    title: "Total Jobs",
    subtitle: "Flarion Enabled",
    titleValue: 0,
    subtitleValue: 0,
    smallBoxValue: 0,
    smallBoxSuffix: '%',
    fill: "yellowFlarion",
    icon: 'arrowTopRight'
  },
  {
    title: "Annual Potential Savings",
    titlePrefix: "$",
    titleValue: 0,
    fill: "white",
    icon: 'arrowTopRight'
  },
  {
    title: "Compute Time Reduction",
    subtitle: "Resource Savings",
    titleValue: 0,
    titleSuffix: '%',
    fill: "white",
    smallBoxValue: 0,
    smallBoxSuffix: '%',
    icon: 'arrowTopRight'
  },
  {
    title: "Flarion Savings",
    subtitle: "Annualized Savings",
    titleValue: 0,
    titlePrefix: "$",
    fill: "white",
    smallBoxValue: 0,
    smallBoxPrefix: "$",
    icon: 'arrowTopRight'
  }
];

export const smallMetrics = [
  {
    title: "Active Jobs",
    titleValue: 0,
    fill: "white",
    icon: 'activeJobs'
  },
  {
    title: "Failed Jobs",
    titleValue: 0,
    fill: "white",
    icon: 'failedJobs'
  },
  {
    title: "Failure Rate",
    titleValue: 0,
    titleSuffix: "%",
    fill: "white",
    icon: 'failureRate'
  },
  {
    title: "Avg. Job Duration",
    titleValue: 0,
    titleSuffix: "m",
    fill: "white",
    icon: 'jobDuration'
  },
  {
    title: "Resource Utilization",
    titleValue: 0,
    titleSuffix: "%",
    fill: "white",
    icon: 'resourceUtilization'
  },
  {
    title: "Avg. CPU Cores/Job",
    titleValue: 0,
    fill: "white",
    icon: 'cpuCores'
  }
];

// Generate mock resource utilization data
export const resourceUtilizationData = Array.from({ length: 31 }, (_, i) => {
  const day = 31 - i;
  return {
    day,
    flarionCPU: 0,
    sparkCPU: 0,
    flarionMemory: 0,
    sparkMemory: 0
  };
}).reverse();

export const resourceUtilizationSeries = [
  { dataKey: 'flarionCPU', label: 'Flarion CPU' },
  { dataKey: 'sparkCPU', label: 'Spark CPU' },
  { dataKey: 'flarionMemory', label: 'Flarion Memory' },
  { dataKey: 'sparkMemory', label: 'Spark Memory' }
];

// Generate mock error data
export const errorData = Array.from({ length: 30 }, (_, i) => ({
  day: i + 1,
  OutOfMemoryError: 0,
  JobAbortedStageFailure: 0,
  shuffleFetchFailedException: 0,
  NotSerializableException: 0,
  OtherError: 0,
}));

export const errorSeries = [
  { dataKey: 'OutOfMemoryError', label: 'OutOfMemoryError' },
  { dataKey: 'JobAbortedStageFailure', label: 'Job aborted: Stage Failure' },
  { dataKey: 'shuffleFetchFailedException', label: 'shuffle.FetchFailedException' },
  { dataKey: 'NotSerializableException', label: 'NotSerializableException' },
  { dataKey: 'OtherError', label: 'Other Error' }
];

// Savings opportunities data
export const savingsOpportunities = [];

// Pie chart data
export const pieChartData = {
  jobStatus: [
    { label: 'Completed', percentage: 100 },
    { label: 'Running', percentage: 0 },
    { label: 'Failed', percentage: 0 },
    { label: 'Pending', percentage: 0 },
    { label: 'Canceled', percentage: 0 }
  ],
  jobCost: [
    { label: '<$1k', percentage: 100 },
    { label: '$1k-$5k', percentage: 0 },
    { label: '$5k-$20k', percentage: 0 },
    { label: '>$20k', percentage: 0}
  ],
  jobDuration: [
    { label: '<10m', percentage: 100 },
    { label: '10m-30m', percentage: 0 },
    { label: '30m-2h', percentage: 0 },
    { label: '>2h', percentage: 0 }
  ]
};